import React from 'react'
import { makeStyles, Tooltip } from '@material-ui/core'

type CustomTooltipProps = {
  value: React.ReactNode
  children: React.ReactElement
  openingType?: 'hover' | 'click'
  maxWidth?: 'sm' | 'md' | 'lg' | number
}

export const CustomTooltip = (props: CustomTooltipProps) => {
  const { value, children, openingType = 'hover', maxWidth } = props

  const [open, setOpen] = React.useState(false)

  const getMaxWidth = () => {
    switch (maxWidth) {
      case 'sm':
        return 300
      case 'md':
        return 550
      case 'lg':
        return 700
      default:
        return maxWidth
    }
  }

  const useTooltipStyle = makeStyles((theme) => ({
    tooltip: {
      padding: '15px',
      backgroundColor: '#ffffff',
      color: '#000000',
      fontSize: 18,
      boxShadow: theme.shadows[3],
      maxWidth: getMaxWidth(),
    },
  }))

  const classes = useTooltipStyle()

  return (
    <Tooltip
      classes={classes}
      title={value ?? ''}
      placement="bottom"
      interactive={openingType === 'click'}
      open={openingType === 'click' ? open : undefined}
      onClick={() => {
        setOpen(!open)
      }}
    >
      {children}
    </Tooltip>
  )
}
